<template>
  <!-- 头部分类选择 -->
  <div class="content-classify" @mouseenter="showClassify = true" @mouseleave="showClassify = false">
    <template v-if="loading">
      <el-skeleton animated>
        <template slot="template">
      <div class="title">
        <el-skeleton-item variant="h3" style="width: 10%; height: 30px;" />
        <el-skeleton-item variant="button " />
      </div>
      <div class="classify-container">
       <div class="classify-box">
        <el-skeleton-item variant="p" style="height: 40px;" />
       </div>
      </div>
    </template>
    </el-skeleton>
    </template>
    <template v-else>
      <div class="title">
        <el-breadcrumb class="title-breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>{{ selectClassify == null ? '全部分类' : data[selectClassify].name }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            childIndex == null ? '' : data[selectClassify].children[childIndex].name
          }}
          </el-breadcrumb-item>
        </el-breadcrumb>
        <el-button type="text" size="mini" class="title-text" @click="clearSelect">刷新</el-button>
      </div>
      <div class="classify-container">
        <!-- 一级分类 -->
        <div class="classify-box">
          <div class="classify-item" v-for="(item, index) in data" :key="index"
            :class="{ 'classify-item-active': selectClassify === index }" @mouseenter="selectClassify = index">
            {{ item.name }}
          </div>
        </div>

        <!-- 二级分类 -->
        <div class="classify-content" v-if="selectClassify != null && showClassify">
          <div class="classify-content-wrapper">
            <div class="classify-content-item" v-for="(item, index) in data[selectClassify].children" :key="index"
              @click="changeClassify(selectClassify, index, item.id)">
              <div class="classify-content-item-title">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>


  </div>
</template>
<script>
export default {
  name: "classfily",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: "shop",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showClassify: false,
      childIndex: null,
      selectClassify: null,
      classifyList: [],
    };
  },
  methods: {
    // 清空选择
    clearSelect() {
      this.selectClassify = null;
      this.childIndex = null;
      this.$emit("changeClassify", '');
    },
    changeClassify(index, ind, id) {
      this.childIndex = ind;
      this.showClassify = false;
      this.$emit("changeClassify", id);
    },
  },
};
</script>
<style lang="scss" scoped>
.content-classify {
  position: relative;
  margin: 30px 0;
  width: 100%;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

  .classify-container {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .title {
    padding: 10px;
    border-bottom: 1px solid #eef0f5;
    color: #333;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title-breadcrumb {
      font-size: 16px;
      color: #999;
    }

    .title-text {
      color: #3860f4;
      font-size: 16px;
      cursor: pointer;
    }
  }

  .classify-box {
    display: flex;
    padding: 20px;
    flex-wrap: wrap;
    gap: 20px;
    border-bottom: 1px solid #eef0f5;
    background: #fff;
    border-radius: 12px 12px 0 0;

    .classify-item {
      font-size: 16px;
      font-weight: 600;
      color: #666;
      padding: 8px 16px;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;
      box-sizing: border-box;
      background: #f8f9fc;

      &:hover {
        color: #3860f4;
        background: rgba(56, 96, 244, 0.05);
      }

      &.classify-item-active {
        color: #3860f4;
        background: rgba(56, 96, 244, 0.1);
        font-weight: 600;
        box-sizing: border-box;

        // &::after {
        //   content: '';
        //   position: absolute;
        //   bottom: -20px;
        //   left: 50%;
        //   transform: translateX(-50%);
        //   width: 20px;
        //   height: 3px;
        //   background: #3860f4;
        //   border-radius: 2px;
        // }
      }
    }
  }

  .classify-content {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    border-radius: 0 0 12px 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 10;
    padding: 20px;
    border: 1px solid #eef0f5;
    border-top: none;

    .classify-content-wrapper {
      max-height: 300px;
      overflow-y: auto;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      gap: 16px;
      padding-right: 10px;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: #e0e0e0;
        border-radius: 3px;
      }

      &::-webkit-scrollbar-track {
        background: #f5f5f5;
      }

      .classify-content-item {
        padding: 12px 16px;
        background: #f8f9fc;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          background: #eef2ff;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(56, 96, 244, 0.1);
        }

        .classify-content-item-title {
          font-size: 16px;
          color: #333;
          font-weight: 500;
          text-align: center;
        }
      }
    }
  }
}
</style>
